import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    ISupporterEditCompanyProfileClient,
} from 'interfaceAdapter/gatewaySchemas/ISupporterEditCompanyProfileClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/supporter/edit/company/profile`;

export class SupporterEditCompanyProfileClient implements ISupporterEditCompanyProfileClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, company } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-S': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify(company);

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
